export const AUTHORIZATIONS_DRAFT_QUERY_KEYS = {
  GET_AUTHORIZATIONS_DRAFT: 'GET_AUTHORIZATIONS_DRAFT',
  GET_AUTHORIZATION_DRAFT: 'GET_AUTHORIZATION_DRAFT',
}